import type { History } from 'history';
import type { MouseEvent } from 'react';

import { matchC2L, matchRoute } from './matchRoute';

/**
 * handle incoming C2Ls.  Matches incoming C2L with regex in ./routes
 * Params are extracted where appropriate.  NB. Not all C2Ls are supported - see ./routes
 * @param c2lPath - incoming c2l path string
 * @param history - route history
 */
export const c2lHandler = (c2lPath: string, history: History) => {
  const matchedC2LRoute = matchC2L(c2lPath);
  if (matchedC2LRoute?.route.handler) {
    matchedC2LRoute.route.handler(matchedC2LRoute.match, history);
  }
};

export const routeHandler = (
  path: Nullable<string | undefined>,
  history: History,
  event?: MouseEvent
) => {
  const matchedRoute = path && matchRoute(path);
  if (matchedRoute) {
    event?.preventDefault();
    if (matchedRoute.route.handler) {
      matchedRoute.route.handler(matchedRoute.match, history);
    }
  }
};
